import { render, staticRenderFns } from "./paypal.vue?vue&type=template&id=2781cfa7&scoped=true"
import script from "./paypal.vue?vue&type=script&lang=js"
export * from "./paypal.vue?vue&type=script&lang=js"
import style0 from "./paypal.vue?vue&type=style&index=0&id=2781cfa7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2781cfa7",
  null
  
)

export default component.exports